import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import BootstrapVue from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from "vee-validate/dist/vee-validate.full.esm";
import VueCompositionAPI from '@vue/composition-api'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import JsonViewer from 'vue-json-viewer'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
// import '@/libs/http'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/recaptcha'

// Axios Mock Adapter
import '@/@fake-db/db'

// vxe-table
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css'

import VueCookies from 'vue-cookies'

import UUID from "vue-uuid";


Vue.use(VXETable)
Vue.use(ElementUI, {locale})
Vue.use(JsonViewer)
// fontAwesome
import 'font-awesome/scss/font-awesome.scss'

Vue.use(BootstrapVue)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.use(VueCookies)
Vue.use(UUID);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
